module.exports = __webpack_public_path__ + "static/media/240-azores-islands.41644218.svg";